import { render } from "./CurrencySelector.vue?vue&type=template&id=fa2ab2f6"
import script from "./CurrencySelector.vue?vue&type=script&lang=js"
export * from "./CurrencySelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/CurrencySelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa2ab2f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa2ab2f6', __exports__)) {
    api.reload('fa2ab2f6', __exports__)
  }
  
  module.hot.accept("./CurrencySelector.vue?vue&type=template&id=fa2ab2f6", () => {
    api.rerender('fa2ab2f6', render)
  })

}


export default __exports__